(function () {
  var CART_SECTION = 'cart-helper';
  var ANIM_MS = 580;
  var crosssellRefreshTimer;
  var cartChangeInFlight = false;

  function formatMoney(cents) {
    var value = Number(cents);
    if (!isFinite(value)) return '₹ 0';
    return '₹ ' + Math.round(value / 100).toLocaleString('en-IN');
  }

  function getCartSidebar() {
    return document.getElementById('site-cart-sidebar');
  }

  function isMiniCartActive() {
    var sidebar = getCartSidebar();
    return !!(sidebar && sidebar.classList.contains('tb-mini-cart'));
  }

  function updateCartCount(count) {
    var countEl = document.querySelector('[data-header-cart-count]');
    var cartCount = document.querySelector('#AjaxCartForm [data-cart-count]');
    if (cartCount) cartCount.textContent = count;
    if (countEl) countEl.textContent = count;

    var itemCountEl = document.querySelector('[data-tb-mc-item-count]');
    if (itemCountEl) {
      itemCountEl.textContent = count + (count === 1 ? ' Item' : ' Items');
    }
  }

  function syncCartEmptyState(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var footer = document.querySelector('#AjaxCartSubtotal .cart__footer');
    var cartItems = document.querySelector('#AjaxCartForm .cart-items');

    if (footer) {
      footer.classList.toggle('cart--empty', count === 0);
    }

    if (cartItems && count === 0 && !cartItems.querySelector('.tb-mc__empty')) {
      cartItems.innerHTML = '<p class="tb-mc__empty">Your bag is empty — add something you love.</p>';
    }
  }

  function scheduleCrosssellRefresh() {
    clearTimeout(crosssellRefreshTimer);
    crosssellRefreshTimer = setTimeout(refreshCrosssellOnly, 200);
  }

  function initCrosssellMedia(root) {
    root = root || document.querySelector('#AjaxCartForm .tb-mc-crosssell');
    if (!root) return;

    root.querySelectorAll('.lazy-image img').forEach(function (img) {
      if (img.dataset.src && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) {
        img.src = img.dataset.src;
      }
      img.classList.add('lazyloaded');
      img.style.opacity = '1';
      img.style.transform = 'none';
    });

    if (typeof window.preloadImages === 'function') {
      window.preloadImages(root);
    }
  }

  function refreshCrosssellOnly() {
    return fetch('/?section_id=' + CART_SECTION)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newCrosssell = doc.querySelector('.tb-mc-crosssell');
        var scroll = document.querySelector('#AjaxCartForm .tb-mc__scroll');
        var currentCrosssell = document.querySelector('#AjaxCartForm .tb-mc-crosssell');

        if (!scroll) return;

        if (newCrosssell) {
          var crosssellHtml = newCrosssell.outerHTML;
          if (currentCrosssell) {
            currentCrosssell.outerHTML = crosssellHtml;
          } else {
            scroll.insertAdjacentHTML('beforeend', crosssellHtml);
          }
          initCrosssellMedia();
        } else if (currentCrosssell) {
          currentCrosssell.remove();
        }
      });
  }

  function changeCartLine(itemEl, quantity) {
    if (cartChangeInFlight) return Promise.resolve();
    if (!itemEl || !itemEl.dataset.id) return Promise.resolve();

    cartChangeInFlight = true;

    var cartForm = document.getElementById('AjaxCartForm');
    var innerForm = cartForm && cartForm.querySelector('form.cart');
    if (innerForm) innerForm.classList.add('processing');

    if (quantity === 0) {
      itemEl.classList.add('is-removing');
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: itemEl.dataset.id, quantity: Math.max(0, quantity) })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || cart.status === 422) {
          throw new Error((cart && cart.description) || 'Cart update failed');
        }

        syncTotalsFromCart(cart);
        updateCartCount(cart.item_count);
        syncCartEmptyState(cart);

        return refreshMiniCartSection().then(function () {
          if (cart.item_count > 0) {
            scheduleCrosssellRefresh();
          }
          if (window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.schedule === 'function') {
            window.TBFreeGiftGuard.schedule();
          }
          return cart;
        });
      })
      .catch(function () {
        return refreshMiniCartSection();
      })
      .finally(function () {
        cartChangeInFlight = false;
        if (innerForm) innerForm.classList.remove('processing');
        if (itemEl.parentNode) itemEl.classList.remove('is-removing');
      });
  }

  function bindCartItemActions() {
    var cartForm = document.getElementById('AjaxCartForm');
    if (!cartForm || cartForm.dataset.tbCartActions === 'true') return;
    cartForm.dataset.tbCartActions = 'true';

    cartForm.addEventListener(
      'click',
      function (e) {
        if (!isMiniCartActive()) return;

        var item = e.target.closest('.cart-item');
        if (!item || !cartForm.contains(item)) return;

        if (e.target.closest('.remove')) {
          e.preventDefault();
          e.stopPropagation();
          changeCartLine(item, 0);
          return;
        }

        if (e.target.closest('.less')) {
          e.preventDefault();
          e.stopPropagation();
          var lessQty = parseInt(item.querySelector('.qty')?.value || item.dataset.qty || '1', 10) - 1;
          if (lessQty >= 0) changeCartLine(item, lessQty);
          return;
        }

        if (e.target.closest('.more')) {
          e.preventDefault();
          e.stopPropagation();
          var moreQty = parseInt(item.querySelector('.qty')?.value || item.dataset.qty || '0', 10) + 1;
          changeCartLine(item, moreQty);
        }
      },
      true
    );
  }

  function refreshMiniCartSection() {
    return fetch('/?section_id=' + CART_SECTION)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var form = doc.getElementById('AjaxCartForm');
        var subtotal = doc.getElementById('AjaxCartSubtotal');
        var currentForm = document.getElementById('AjaxCartForm');
        var currentSubtotal = document.getElementById('AjaxCartSubtotal');

        if (form && currentForm) {
          currentForm.innerHTML = form.innerHTML;
        }

        if (subtotal && currentSubtotal) {
          currentSubtotal.innerHTML = subtotal.innerHTML;
        }

        var cartCount = document.querySelector('#AjaxCartForm [data-cart-count]');
        if (cartCount) {
          updateCartCount(parseInt(cartCount.textContent, 10) || 0);
        }

        bindDiscountForm();
        initCrosssellMedia();

        var count = parseInt(
          document.querySelector('#AjaxCartForm [data-cart-count]')?.textContent || '0',
          10
        );
        syncCartEmptyState({ item_count: count });

        if (typeof window.updateFreeGiftsText === 'function') {
          window.updateFreeGiftsText();
        }

        if (window.TBFreeGiftGuard && typeof window.TBFreeGiftGuard.schedule === 'function') {
          window.TBFreeGiftGuard.schedule();
        }
      });
  }

  function syncTotalsFromCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    var subtotalEl = document.querySelector('[data-tb-mc-subtotal]');
    var totalEl = document.querySelector('[data-tb-mc-total]');
    var discountWrap = document.querySelector('[data-tb-mc-discount-rows]');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    if (discountWrap) {
      discountWrap.innerHTML = '';
      (cart.cart_level_discount_applications || []).forEach(function (discount) {
        var row = document.createElement('p');
        row.className = 'tb-mc__row tb-mc__row--discount';
        row.innerHTML = '<span>' + discount.title + '</span><span>-' + formatMoney(discount.total_allocated_amount) + '</span>';
        discountWrap.appendChild(row);
      });
    }

    renderDiscountTags(cart);
  }

  function renderDiscountTags(cart) {
    var tags = document.querySelector('[data-tb-mc-discount-tags]');
    if (!tags) return;
    tags.innerHTML = '';

    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      var tag = document.createElement('span');
      tag.className = 'tb-mc__discount-tag';
      tag.innerHTML =
        '<span>' +
        discount.title +
        '</span><button type="button" class="tb-mc__discount-remove" data-tb-mc-discount-remove aria-label="Remove discount">×</button>';
      tags.appendChild(tag);
    });
  }

  function setDiscountMessage(text, type) {
    var msg = document.querySelector('[data-tb-mc-discount-message]');
    if (!msg) return;
    if (!text) {
      msg.hidden = true;
      msg.textContent = '';
      msg.className = 'tb-mc__discount-message';
      return;
    }
    msg.hidden = false;
    msg.textContent = text;
    msg.className = 'tb-mc__discount-message tb-mc__discount-message--' + (type || 'success');
  }

  function applyDiscountCode(code) {
    code = (code || '').trim();
    if (!code) {
      setDiscountMessage('Enter a discount code.', 'error');
      return Promise.resolve();
    }

    var applyBtn = document.querySelector('[data-tb-mc-discount-apply]');
    if (applyBtn) applyBtn.disabled = true;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart.status && cart.status === 422) {
          setDiscountMessage(cart.description || cart.message || 'Invalid discount code.', 'error');
          return;
        }

        try {
          localStorage.setItem('tb_mc_discount', code);
        } catch (e) {}

        setDiscountMessage('Discount applied.', 'success');
        syncTotalsFromCart(cart);
        return refreshMiniCartSection();
      })
      .catch(function () {
        setDiscountMessage('Could not apply discount. Try again.', 'error');
      })
      .finally(function () {
        if (applyBtn) applyBtn.disabled = false;
      });
  }

  function removeDiscountCode() {
    try {
      localStorage.removeItem('tb_mc_discount');
    } catch (e) {}

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setDiscountMessage('', '');
        syncTotalsFromCart(cart);
        return refreshMiniCartSection();
      });
  }

  function bindDiscountForm() {
    var form = document.querySelector('[data-tb-mc-discount-form]');
    if (!form || form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    var input = form.querySelector('[data-tb-mc-discount-input]');
    var applyBtn = form.querySelector('[data-tb-mc-discount-apply]');

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        applyDiscountCode(input ? input.value : '');
      });
    }

    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDiscountCode(input.value);
        }
      });
    }
  }

  function patchCartDrawerAnimation() {
    var sidebar = getCartSidebar();
    if (!sidebar || sidebar.__tbMcAnimPatched) return;
    sidebar.__tbMcAnimPatched = true;

    if (typeof sidebar.hide === 'function') {
      var originalHide = sidebar.hide.bind(sidebar);
      sidebar.hide = function () {
        originalHide();
        clearTimeout(sidebar.__tbMcHideTimer);
        sidebar.__tbMcHideTimer = setTimeout(function () {
          if (!sidebar.classList.contains('sidebar--opened')) {
            sidebar.style.display = 'none';
          }
        }, ANIM_MS);
      };
    }
  }

  function tryAutoApplyStoredDiscount() {
    var stored = '';
    try {
      stored = localStorage.getItem('tb_mc_discount') || '';
    } catch (e) {}

    if (!stored) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var hasDiscount = (cart.cart_level_discount_applications || []).length > 0;
        if (hasDiscount) {
          syncTotalsFromCart(cart);
          return;
        }
        return applyDiscountCode(stored);
      });
  }

  function disableThemeCartFormHandlers() {
    var cartFormEl = document.getElementById('AjaxCartForm');
    if (!cartFormEl || !isMiniCartActive()) return;

    cartFormEl.ajaxifyCartItems = function () {};
    cartFormEl.updateCartQty = function () {};
  }

  function init() {
    disableThemeCartFormHandlers();
    bindCartItemActions();
    bindDiscountForm();
    initCrosssellMedia();
    patchCartDrawerAnimation();
    tryAutoApplyStoredDiscount();

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-tb-mc-discount-remove]')) {
        e.preventDefault();
        removeDiscountCode();
      }
    });
  }

  window.TBMiniCart = {
    refresh: refreshMiniCartSection,
    syncTotals: syncTotalsFromCart,
    applyDiscount: applyDiscountCode,
    removeDiscount: removeDiscountCode,
    formatMoney: formatMoney
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(patchCartDrawerAnimation, 300);
})();
